import { memo/*, useEffect*/ } from "react";

const InputText = ({value, setValue, name, onChange}) => {

    // useEffect(() => console.log("Render - InputText"));

    return (
        <input
            type="text"
            className="form-control form-control-sm"
            onChange={onChange || (e => setValue(e.target.value))}
            value={value}
            name={name}
        />
    )
};
export default memo(InputText);